import React from "react";
import { Typography, Paper } from "@mui/material";
import { useGetScheduledCoursesQuery } from "../../../services/ScheduledCourse/scheduledCourseApi";
import CourseDetailDisplay from "./CourseDetailDisplay";
import CenteredLoading from "../../../layout/CenteredLoading";

/** @typedef {import('../../../Dtos/ScheduleGetAllResponseDto').ScheduleGetAllResponseDto} ScheduleGetAllResponseDto */


const ScheduledCourseContainer = () => {
    const { data, isFetching } = useGetScheduledCoursesQuery();

    if (isFetching)
        return <CenteredLoading tekst={"Laster inn planlagte kurs…"} />;

    /** @type {ScheduleGetAllResponseDto[]} */
    const courses = data?.data ?? [];

    const uniqueGroupIds = [...new Set(courses.map((course) => course.groupId))].reverse();

    /** @type {ScheduleGetAllResponseDto[][]} */
    const groupedCourses = uniqueGroupIds.map((groupId) =>
        courses.filter((course) => course.groupId === groupId)
    );

    return (
        <>
            {groupedCourses.length ? (
                groupedCourses.map((group, i) => (
                    <CourseDetailDisplay
                        key={i}
                        course={group}
                        data={courses}
                    />
                ))
            ) : (
                <Paper sx={{ padding: 2, marginTop: 6, textAlign: "center" }}>
                    <Typography>Det er for øyeblikket ingen planlagte kurs.</Typography>
                </Paper>
            )}
        </>
    );
};

export default ScheduledCourseContainer;